// extracted by mini-css-extract-plugin
module.exports = {"list":"_2-Lir","item":"_1Ew2I","link":"H3mXw"};